module.exports = __webpack_public_path__ + "img/youtube.b5f5d4cc.svg";